import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';

import { AccidentModel, DatePeriodParams } from '../../models';
import { accidentsListAllTimeMock, accidentsListDayMock, accidentsListWeekMock } from './mocks/accidents-list.mock';

@Injectable({ providedIn: 'root' })
export class AccidentsApiService {
  getList(params: DatePeriodParams): Observable<AccidentModel[]> {
    let result: Observable<AccidentModel[]>;
    switch (params.period) {
      case 'hour':
        result = this.getHourPeriodList();
        break;
      case 'day':
        result = this.getDayPeriodList();
        break;
      case 'month':
        result = this.getMonthPeriodList();
        break;
      default:
        result = this.getHourPeriodList();
    }

    return result.pipe(delay(1000));
  }

  private getHourPeriodList(): Observable<AccidentModel[]> {
    return of(accidentsListDayMock);
  }

  private getDayPeriodList(): Observable<AccidentModel[]> {
    return of(accidentsListWeekMock);
  }

  private getMonthPeriodList(): Observable<AccidentModel[]> {
    return of(accidentsListAllTimeMock);
  }
}
